import { gql } from "@apollo/client";

const USER_FIELDS = gql`
  fragment UserFields on User {
    id
    name
    email
    role
    avatar
  }
`;

const EVENT_FIELDS = gql`
  fragment EventFields on Event {
    uuid
    title
    subtitle
    description
    imageUrl
    bannerUrl
    url
    numberOfViews
    numberOfDps
    tags
    visible
    eventDate
    imageAttribute {
      shape
      radius
      x
      y
      height
      width
      position
    }
    nameAttribute {
      x
      y
      height
      width
      position
      fontFamily
      fontSize
      fontWeight
      fontStyle
      textTransform
      textColor
      textAlign
    }
    createdAt
    updatedAt
  }
`;

export { USER_FIELDS, EVENT_FIELDS };
